import { useNavigate } from "react-router-dom";
import { SereneHeart, Wordmark, Lockup, ASSETS } from "@/lib/brand";

function PublicShell({ children }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#F3EEE4] text-[#2E2A22]">
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#F3EEE4]/85 border-b border-[#DCD1BC]">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          <button onClick={() => navigate("/")} className="flex items-center gap-3" data-testid="public-nav-home">
            <SereneHeart size={22} tone="ink" />
            <Wordmark height={15} />
          </button>
          <div className="flex items-center gap-6">
            <button data-testid="public-nav-serenismm" onClick={() => navigate("/about-serenismm")} className="text-[11px] tracking-[0.25em] uppercase text-[#6B6151] hover:text-[#2E2A22]">About</button>
            <button data-testid="public-nav-founder" onClick={() => navigate("/about-founder")} className="text-[11px] tracking-[0.25em] uppercase text-[#6B6151] hover:text-[#2E2A22]">The Founder</button>
            <button data-testid="public-nav-enter" onClick={() => navigate("/login")} className="text-[11px] tracking-[0.25em] uppercase text-[#A98F63]">Members</button>
          </div>
        </div>
      </header>
      {children}
      <footer className="border-t border-[#DCD1BC] mt-24 bg-[#E8DFCF]">
        <div className="max-w-7xl mx-auto px-6 py-14 text-center space-y-3">
          <Lockup height={64} className="mx-auto" />
          <p className="text-[10px] tracking-[0.4em] text-[#9C907A]">ONE SOUL, ONE UNIVERSE · LA. CALIFORNIA</p>
        </div>
      </footer>
    </div>
  );
}

function Statement({ kicker, text }) {
  return (
    <div className="max-w-2xl mx-auto px-6 py-20 text-center space-y-4">
      <p className="text-[11px] tracking-[0.4em] text-[#A98F63]">{kicker}</p>
      <p className="font-serif text-2xl sm:text-3xl tracking-[0.06em] text-[#2E2A22] leading-relaxed">{text}</p>
    </div>
  );
}

const Full = ({ src }) => <div className="w-full"><img src={src} alt="" className="w-full h-[60vh] min-h-[380px] object-cover" /></div>;

export function AboutSerenismm() {
  return (
    <PublicShell>
      <div data-testid="about-serenismm">
        <section className="relative h-[64vh] min-h-[440px] overflow-hidden">
          <img src={ASSETS.boutique} alt="SERENISMM" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#2E2A22]/30" />
          <div className="relative h-full flex flex-col items-center justify-center text-center px-6">
            <p className="text-[11px] tracking-[0.5em] text-[#F3EEE4] mb-6">ONE SOUL, ONE UNIVERSE</p>
            <h1 className="sr-only">SERENISMM</h1>
            <Lockup height={150} tone="ivory" className="mx-auto" />
          </div>
        </section>
        <Statement kicker="THE HOUSE" text="A private house of quiet luxury, born in Los Angeles." />
        <Full src={ASSETS.editorial} />
        <Statement kicker="CLOTHING BEYOND GENDER" text="One unified wardrobe of essentials, worn by anyone — never divided into men and women." />
        <Full src={ASSETS.journal} />
        <Statement kicker="COUTURE CRAFT" text="The Serene Heart, set by hand in Japanese glass beads — a mark felt more than seen." />
        <div className="py-20 text-center"><p className="text-[11px] tracking-[0.5em] text-[#A98F63]">CRAFT · SILENCE · SERENITY</p></div>
      </div>
    </PublicShell>
  );
}

export function AboutFounder() {
  return (
    <PublicShell>
      <div data-testid="about-founder">
        <section className="relative h-[56vh] min-h-[380px] overflow-hidden">
          <img src={ASSETS.world} alt="" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#2E2A22]/35" />
          <div className="relative h-full flex flex-col items-center justify-center text-center px-6">
            <Wordmark height={14} tone="ivory" className="mx-auto mb-5" />
            <h1 className="font-serif text-4xl sm:text-5xl tracking-[0.16em] text-[#F3EEE4]">THE FOUNDER</h1>
          </div>
        </section>
        <Statement kicker="A VISION OF CALM" text="SERENISMM began with a simple conviction: that true luxury is quiet." />
        <Full src={ASSETS.editorial} />
        <div className="max-w-2xl mx-auto px-6 py-20 space-y-6 text-center">
          <p className="text-sm text-[#6B6151] font-light leading-loose">
            Drawn to the serenity of Aman retreats, the warmth of stone and plaster, and the discipline of Japanese craft,
            the founder set out to build a house where clothing is unhurried and deeply felt.
          </p>
          <p className="text-[11px] tracking-[0.3em] text-[#9C907A]">— SERENISMM, LA. CALIFORNIA</p>
        </div>
      </div>
    </PublicShell>
  );
}
